































import {
  Consultor,
  ConsultoresService,
  FiltroPesquisa,
} from "@/services/consultores.service";
import { highlight } from "@/shared/filters";
import { getServerOptions } from "@/shared/utils/datatable";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, VModel } from "vue-property-decorator";
import AutoComplete, { AutoCompletePageOptions } from "../auto-complete.vue";
import ConsultorAutoCompleteSelecionado from "./consultor-auto-complete-selecionado.vue";

@Component({
  components: {
    AutoComplete,
    ConsultorAutoCompleteSelecionado,
  },
})
export default class ConsultorAutoComplete extends Vue {
  @VModel() idConsultor!: number;
  @Prop({ required: false, default: () => [] }) readonly rules!: Array<
    (value: any) => string | null | undefined
  >;
  @Prop({ required: false, default: "Consultor" }) readonly label!: string;
  @Prop() readonly placeholder!: string;
  appendIcon = "";

  promise: Promise<any[]> | null = null;
  search: string | null = null;

  /**
   * Há um bug no VAutoComplete do vuetify que não funciona bem items cacheados e no-filter
   * então tive que fazer uma função para filtrar os itens cacheados para manter a exibição do valor selecionado
   * caso a pesquise mude e este item suma da lista de exibição
   */
  filter(consultor: Consultor, pesquisa: string) {
    return (
      consultor.nome.toLocaleLowerCase().indexOf(pesquisa.toLocaleLowerCase()) >
        -1 ||
      ("" + consultor.idConsultor).indexOf(pesquisa.toLocaleLowerCase()) > -1
    );
  }

  mounted() {
    this.fetchConsultores({ itemsPerPage: 20, page: 1 });
  }

  fetchConsultores(options?: AutoCompletePageOptions) {
    const filtro: Partial<FiltroPesquisa> = {
      query: (this.search = options?.search || ""),
    };

    Object.assign(filtro, getServerOptions(options || {}));

    this.promise = ConsultoresService.Pesquisar(filtro as FiltroPesquisa);
  }

  highlight(text: string) {
    return highlight(text, this.search || "");
  }
}
